import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Input, Select, DatePicker, Radio, Checkbox, Collapse, notification, Divider, InputNumber } from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Tabs } from 'antd';
import { EnvironmentOutlined, AuditOutlined, HomeOutlined, FileProtectOutlined, DollarCircleOutlined } from '@ant-design/icons';


import { RecordFormWrapper } from './Style';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper } from '../../styled';
import { tipoOrigenPacienteCreateAction, tipoOrigenPacienteReadAction } from '../../../redux/configuracion/tipoOrigenPaciente/actionCreator';

const dateFormat = 'YYYY-MM-DD';

const TipoOrigenPacienteMainForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  
  const registro = useSelector(state => state.TipoOrigenPacienteCrudReducer.record);
  const isLoading = useSelector(state => state.responseReducer.loading);
  const { id } = useParams(); // Esta funcion nos ayuda a leer los parametros recibidos (en caso de exista)
  const [form] = Form.useForm();


  useEffect(() => {
    if (id) // Cuando se este editando un registro, tendremos un ID en los parametros, por lo tanto podremos buscar en el api este regsitro
      dispatch(tipoOrigenPacienteReadAction(id));
    else {
      dispatch(tipoOrigenPacienteReadAction());
      form.resetFields();
    }
  }, [id]);

  useEffect(() => {
    if (registro.id) { // Cuando la llamada al API fue exitosa, ya tendremos el objecto en la variable "registro" y podemos pasar estos valores al formulario     
      form.setFieldsValue(registro);
    } else {
      form.resetFields();
    }
  }, [form, registro]);

  const handleSubmit = async (values) => { 
    
    let action = 'create';
    if (id) {
      action = 'update';
    }
    const responseApi = await dispatch(tipoOrigenPacienteCreateAction({
      ...values,
      action: action
    }));    
    if (responseApi) {
      let mensaje = 'Tipo origen paciente creado exitosamente';
      if (action === "update") mensaje = 'Tipo origen paciente actualizado exitosamente';
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      history.replace('/admin/catalogos/tipo-origen-paciente/listado');
    } else {
      notification.error({
        message: 'Error al gestionar tipo origen paciente',
      });
    }
  };

  return (
    <>
      <PageHeader
        buttons={[
          <Button className="btn-add_new" size="default" key="1" type="primary">
            <Link to="/admin/catalogos/tipo-origen-paciente/listado">Ver todos</Link>
          </Button>,
        ]}
        ghost
        title="FICHA DEl TIPO ORIGEN PACIENTE"
      />
      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            <Form
              className="add-record-form"
              style={{ width: '100%' }}
              layout="horizontal"
              size="small"
              form={form}
              name="addnew"
              onFinish={handleSubmit}
            >
              <RecordFormWrapper>
                <Cards headless>
                  <BasicFormWrapper>                  
                    <Form.Item name="nombre" label="Nombre origen" rules={[{ message: 'Campo obligatorio', required: true }]}>
                      <Input placeholder="Ej. Ventas" />
                    </Form.Item>                   
                    <Form.Item name="id" initialValue="0" noStyle>
                      <Input hidden />
                    </Form.Item>                
                  </BasicFormWrapper>

                  <br />
                  <div className="record-form-actions text-right">
                    <Button size="default" htmlType="Save" type="primary">
                      {isLoading ? 'Cargando...' : 'Guardar'}
                    </Button>
                  </div>
                </Cards>
              </RecordFormWrapper>
            </Form>
          </Col>
        </Row>
      </Main>
    </>
  );
};

export default TipoOrigenPacienteMainForm;
